<template>
  <div id="app-notification" class="notification"></div>
</template>

<script>
export default {
  name: "Notifications",
  data() {
    return {};
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#app .notification {
  position: fixed;
  top: 2em;
  left: 10%;
  width: 80%;
  z-index: 2000;

  div {
    border: solid 0.1rem #dddddd;
    background-color: $white;
    padding: 1em 1.5em 1em 1.5em;
    text-align: left;

    h5 {
      border-bottom: solid 0.05em #dddddd;
      padding-bottom: 0.5em;
    }

    img.close {
      position: absolute;
      top: 0.7em;
      right: 0.6em;
      z-index: 2001;
      width: 0.9em;
      height: 0.9em;
      opacity: 1;
    }

    p {
      position: relative;
      color: $fontColor !important;
      border-bottom: solid 0.05em #ffffff;
      line-height: 2em;
      font-size: 0.9em;
      padding: 0 0 1em 0;

      small {
        display: block;
        line-height: 1.5em;
      }
    }

    p:last-child {
      border-bottom: none;
    }
  }
}

@media (min-width: 992px) {
  #app .notification {
    top: calc(50% - 40rem);
    left: 30%;
    width: 40%;
  }
}
</style>
